// extracted by mini-css-extract-plugin
module.exports = {"content":"ComposeArticle_content__3ptex"};